// Real estate costume v1 — for builders, agents and property consultants.
// Engine stage KEYS never change; only the labels do.

export const REAL_ESTATE_COSTUME = {
  costumeId: "real_estate_v1",

  stages: [
    { key: "new", label: "New" },
    { key: "spoke", label: "Spoke to them" },
    { key: "visit_scheduled", label: "Site visit scheduled" },
    { key: "visited", label: "Site visited" },
    { key: "sent_price", label: "Sent quote" },
    { key: "signed_up", label: "Booked" },
    { key: "lost", label: "Lost" },
  ],

  stageColors: {
    new: "bg-amber-100 text-amber-800 border-amber-200",
    spoke: "bg-orange-100 text-orange-800 border-orange-200",
    visit_scheduled: "bg-yellow-100 text-yellow-800 border-yellow-200",
    visited: "bg-emerald-100 text-emerald-800 border-emerald-200",
    sent_price: "bg-rose-100 text-rose-800 border-rose-200",
    signed_up: "bg-green-100 text-green-800 border-green-200",
    lost: "bg-zinc-200 text-zinc-700 border-zinc-300",
  },

  defaultSources: [
    "Walk-in",
    "Phone call",
    "Website",
    "Property portal",
    "Referral",
    "Social media",
    "Hoarding / site board",
    "Others",
  ],

  lostReasons: [
    "Budget too high",
    "Location not right",
    "Chose another project",
    "Loan / financing fell through",
    "Just exploring",
    "Stopped responding",
    "Plan dropped",
    "Other",
  ],

  enquiryTypes: [
    "Apartment / Flat",
    "Villa / Independent house",
    "Plot / Site",
    "Commercial space",
    "Rental / Lease",
    "Resale",
  ],

  waTemplates: [
    { name: "First contact", body: "Hi {{name}}, this is {{me}} from {{company}}. Thanks for your enquiry — happy to help you find the right property. When is a good time to talk?" },
    { name: "Site visit invite", body: "Hi {{name}}, would you like to come for a site visit? I can show you around at a time that suits you — just tell me a day." },
    { name: "Quote share", body: "Hi {{name}}, sharing the pricing details as discussed: {{quote}}. Happy to walk you through it on a call." },
    { name: "Soft follow-up", body: "Hi {{name}}, just checking in — any thoughts on the property we discussed?" },
    { name: "Polite drop", body: "Hi {{name}}, hope all's well. Closing this for now; whenever you're ready to look again, ping me." },
  ],

  companyInfo: { name: "", me: "", address: "" },

  vocab: {
    unit: "unit",
    units: "units",
    location: "project",
    locations: "projects",
    customer: "buyer",
  },

  copy: {
    appName: "Jigyasa",
    sectionTrend: "Enquiries vs bookings — last 6 months",
    sectionAttention: "Needs your attention",
    attentionAllClear: "All caught up — nothing is waiting on you.",
    attentionWaitingQuote: "waiting after quote",
    remarksTitle: "Remarks & history",
    remarkPlaceholder: "e.g. Wants a 3BHK near the ring road — call Saturday",
    addRemarkButton: "Add",
    remarksEmpty: "No remarks yet — add one after each call so the story stays in one place.",
    settingsSourcesTitle: "Manage enquiry sources",
    settingsSourcesNote: "Each organisation sets up its own list of where enquiries come from. Removing a source never changes past enquiries — it only affects new ones.",
    pastEnquiryBannerLabel: "Returning lead",
    pastEnquiryBannerNote: "We've spoken before — don't start cold.",
    footprintBannerLabel: "Already with us",
    footprintInlineDismiss: "This is someone new — clear and start fresh",
  },

  // Standalone: no host app, so all host-side data buttons are off.
  // Returning-lead detection (button 4) is Jigyasa's own data — stays on.
  buttonsOn: {
    liveStock: false,
    upcomingStock: false,
    customerFootprint: false,
    pastEnquiries: true,
    pricingAndOffers: false,
    activityHistory: false,
    renewalPipeline: false,
    locationCatalog: false,
    satisfaction: false,
    availability: false,
    compliance: false,
    communications: false,
  },
};
